import { createStore, applyMiddleware, compose, GenericStoreEnhancer, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

import {
    appReducer,
    State,
    userReducer,
    userDetailReducer,
    UserState,
    usersReducer,
    quoteReducer,
    addressReducer,
    navbarReducer,
    companyNameSearchReducer,
    step05Reducer,
    step05RenewalsReducer,
    activityTrackerReducer,
    policyMapReducer,
    clientListReducer,
    agencySummaryReducer,
    policiesSingleReducer,
    quotesSingleReducer,
    searchReducer,
    notificationsReducer,
    mtaReducer,
    subjectivitiesReducer,
    reissueQuoteReducer,
    accountListReducer,
    renewalsReducer,
    step00Reducer,
} from './reducers'

import sagaWatchers from './sagas'
import promiseMiddleware from 'redux-promise-middleware'
// const createLogger = require('redux-logger').createLogger()

export type RootState = {
    app: State,
    user: UserState,
    userDetail: any,
    users: any,
    quote: any,
    address: any,
    navBar: any,
    companyNames: any,
    step05: any,
    step05Renewals: any,
    activityTracker: any,
    policyMap: any,
    clientList: any,
    agencySummary: any,
    policiesSingle: any,
    quotesSingle: any,
    search: any,
    notifications: any,
    mta: any,
    subjectivities: any,
    reissueQuote: any,
    accounts: any,
    renewals: any,
    step00: any,
    req_quote: any;
}

const history = createHistory()
const middlewareReduxRouter = routerMiddleware(history)

const sagaMiddleware = createSagaMiddleware()
const reducers = combineReducers({
    router: routerReducer,
    app: appReducer,
    user: userReducer,
    users: usersReducer,
    userDetail: userDetailReducer,
    quote: quoteReducer,
    address: addressReducer,
    navBar: navbarReducer,
    companyNames: companyNameSearchReducer,
    step05: step05Reducer,
    step05Renewals: step05RenewalsReducer,
    activityTracker: activityTrackerReducer,
    policyMap: policyMapReducer,
    clientList: clientListReducer,
    agencySummary: agencySummaryReducer,
    policiesSingle: policiesSingleReducer,
    quotesSingle: quotesSingleReducer,
    search: searchReducer,
    mta: mtaReducer,
    notifications: notificationsReducer,
    subjectivities: subjectivitiesReducer,
    reissueQuote: reissueQuoteReducer,
    accounts: accountListReducer,
    renewals: renewalsReducer,
    step00: step00Reducer,
})
/* tslint:disable no-any no-string-literal */
const devToolsExtension: GenericStoreEnhancer = window['devToolsExtension']
    ? window['devToolsExtension']()
    /* tslint:enable no-any no-string-literal */
    : f => f
const store = createStore(reducers, compose(
    applyMiddleware(
        middlewareReduxRouter,
        sagaMiddleware,
        // createLogger,
        promiseMiddleware()
    ),
    devToolsExtension
) as GenericStoreEnhancer
)

function* rootSaga() {
    yield all(sagaWatchers)
}

sagaMiddleware.run(rootSaga)

export default store



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/store.ts